import { render } from "./FloatingWindowButton.vue?vue&type=template&id=08b73fbe&scoped=true"
import script from "./FloatingWindowButton.vue?vue&type=script&lang=js"
export * from "./FloatingWindowButton.vue?vue&type=script&lang=js"

import "./FloatingWindowButton.vue?vue&type=style&index=0&id=08b73fbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08b73fbe"

export default script